import React from "react";

const Header: React.FC = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-effect">
      <div className="container py-4">
        <nav className="flex items-center justify-between">
          <a
            href="#home"
            className="text-2xl font-bold text-white hover:text-accent transition-colors"
          >
            本気のチンチロ
          </a>
          <div className="hidden md:flex space-x-8">
            <a
              href="#modes"
              className="text-white hover:text-accent transition-colors"
            >
              ゲームモード
            </a>
            <a
              href="#rules"
              className="text-white hover:text-accent transition-colors"
            >
              ルール
            </a>
            <a
              href="#features"
              className="text-white hover:text-accent transition-colors"
            >
              機能
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
